import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TextAndImage } from './core/text-and-image';
import { DEVICE_SIZE } from '../../../../../../core/models/others.model';
import { CmsComponentData } from '@spartacus/storefront';
import { TextAndImageService } from './core/text-and-image.service';

@Component({
  selector: 'text-and-image',
  templateUrl: './text-and-image.component.html',
  styleUrl: './text-and-image.component.scss',
  standalone: false,
})
export class TextAndImageComponent implements OnInit {
  DEVICE_SIZE = DEVICE_SIZE;
  data$ = new BehaviorSubject<TextAndImage | undefined>(undefined);

  constructor(
    private componentData: CmsComponentData<any>,
    private textAndImageService: TextAndImageService,
  ) {}

  ngOnInit(): void {
    this.componentData.data$.subscribe(data => {
      this.data$.next(this.textAndImageService.normalize(data));
    });
  }
}
